/* eslint-disable no-undef */
import React, { useEffect, useState } from 'react'

interface LayoutSelectorProps {
  onLayoutChange: (layout: number[]) => void;
  selectedLayout: number[] | null;
  previousSelectedLayout: string | null | LayoutKey
}

type LayoutKey = 'single' | 'two' | 'three' | 'four' | 'five' | 'six' | 'twelve';

const LayoutSelector: React.FC<LayoutSelectorProps> = ({ onLayoutChange, selectedLayout, previousSelectedLayout }) => {
  const singleColumnLayout = [12] // Default layout for "single"

  const layouts: Record<LayoutKey, number[][]> = {
    single: [[12]],
    two: [[6, 6], [2, 10], [3, 9], [4, 8], [5, 7], [7, 5], [8, 4], [9, 3], [10, 2]],
    three: [[4, 4, 4], [3, 3, 6], [6, 3, 3], [3, 6, 3], [6, 4, 2], [6, 2, 4], [2, 4, 6], [2, 6, 4], [4, 2, 6], [4, 6, 2]],
    four: [[3, 3, 3, 3], [4, 4, 2, 2], [4, 2, 4, 2], [4, 2, 2, 4], [2, 2, 4, 4], [6, 2, 2, 2], [2, 6, 2, 2], [2, 2, 6, 2], [2, 2, 2, 6]],
    five: [[20, 20, 20, 20, 20], [4, 2, 2, 2, 2], [2, 2, 2, 2, 4], [3, 3, 2, 2, 2], [2, 2, 2, 3, 3], [2, 3, 2, 3, 2], [3, 2, 2, 2, 3]],
    six: [[2, 2, 2, 2, 2, 2]],
    twelve: [[1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1]],
  }

  // Track the selected category and last selected layout for each category
  const [selectedCategory, setSelectedCategory] = useState<LayoutKey>('single')
  const [lastSelectedLayout, setLastSelectedLayout] = useState<Record<LayoutKey, number[]>>({
    single: singleColumnLayout,
    two: layouts.two[0],
    three: layouts.three[0],
    four: layouts.four[0],
    five: layouts.five[0],
    six: layouts.six[0],
    twelve: layouts.twelve[0],
  })

  const handleCategoryChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const newCategory = event.target.value as LayoutKey
    setSelectedCategory(newCategory)

    // Retrieve and apply the last selected layout for the new category
    onLayoutChange(lastSelectedLayout[newCategory])
  }

  const handleLayoutSelect = (layout: number[]) => {
    onLayoutChange(layout)

    // Save the selected layout for the current category
    setLastSelectedLayout((prev) => ({
      ...prev,
      [selectedCategory]: layout,
    }))
  }

  useEffect(() => {
    if (previousSelectedLayout) {
      setSelectedCategory(previousSelectedLayout as LayoutKey)
    }
  }, [previousSelectedLayout])
  return (
    <div className="layout-selector">
      <h5 className="d-flex mb-2 align-items-center text-nowrap font-12">Select Layout:
        <select
          id="layout-category"
          className="form-select font-12 form-sm"
          value={selectedCategory}
          onChange={handleCategoryChange}
        >
          {Object.keys(layouts).map((category) => (
            <option key={category} value={category}>
              {category.charAt(0).toUpperCase() + category.slice(1)} Column
              {category === 'single' || layouts[category as LayoutKey].length === 1 ? '' : 's'}
            </option>
          ))}
        </select></h5>

      {/* Select Column Category */}
      {/* <div className="mb-3">
        <label htmlFor="layout-category" className="form-label">Select Column Category:</label>
        
      </div> */}

      {/* Layout Options */}
      <div className="row flex-wrap layout-columns g-1">
        {layouts[selectedCategory].map((layout, idx) => (
          <div
            key={idx}
            className={`my-1 ${selectedCategory === 'single' || selectedCategory === 'six' || selectedCategory === 'five' || selectedCategory === 'twelve'
              ? 'col-12'
              : selectedCategory === 'four'
                ? 'col-6'
                : 'col-12 col-md-6 col-xxl-4'
              } ${selectedCategory === 'single' ? 'active-layout bgcolor-2' : selectedLayout && selectedLayout.toString() === layout.toString() ? 'active-layout bgcolor-2' : ''}`}
            onClick={() => handleLayoutSelect(layout)}
          >
            <ul className="d-flex w-100 flex-nowrap list-type-none">
              {layout.map((col, colIdx) => (
                <li key={colIdx} className={col <= 6 || col === 12 ? `col-${col === 20 ? `${col}per` : col}` : 'col'}>
                  <div className='border-2 whitebg p-1'>{col === 20 ? `${col}%` : col}</div></li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </div>
  )
}

export default LayoutSelector